import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { AgentListDto } from '../../agents/dtos/agent-list.dto';
import { AgreementContactDto } from '../../contacts/dtos/agreement-contact.dto';
import { CustomerListDto } from '../../customers/dtos/customer-list.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleCategoryListDto } from '../../vehicle-categories/dtos/vehicle-category-list.dto';
import { VehicleListDto } from '../../vehicles/dtos/vehicle-list.dto';
import { RentalAgreementRecordCategoryEnum } from '../enums/rental-agreement-record-category.enum';
import { RentalAgreementStatusEnum } from '../enums/rental-agreement-status.enum';
import { RentalAgreementTypeEnum } from '../enums/rental-agreement-type.enum';

import { RentalAgreementLinksDto } from './rental-agreement-links.dto';

/**
 * Rental agreement DTO for lists
 */
@CaslSubject(AppSubjectEnum.RENTAL_AGREEMENT)
export class RentalAgreementListDto extends BaseDto {
  code!: string;
  documentNumber!: string;
  qrCode?: string | null;
  status!: RentalAgreementStatusEnum;
  recordCategory!: RentalAgreementRecordCategoryEnum;
  agreementContact?: AgreementContactDto | null;
  type!: RentalAgreementTypeEnum;
  startsAt!: Date;
  endsAt!: Date;
  vehicle?: VehicleListDto | null;
  vehicleCategory?: VehicleCategoryListDto | null;
  customer?: CustomerListDto | null;
  agent?: AgentListDto | null;
  tags?: TagListDto[] | null;
  links?: RentalAgreementLinksDto | null;

  computedPeriod?: ComputedPeriodDurationDto | null;
  computedTotalNet?: number | null;
  computedTotalTax?: number | null;
  computedTotalGross?: number | null;
  computedCommissionNet?: number | null;
}
